import { render } from "./PropertyServicesListing.vue?vue&type=template&id=558f22f0&ts=true"
import script from "./PropertyServicesListing.vue?vue&type=script&lang=ts"
export * from "./PropertyServicesListing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__